var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHomeLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 10.5658C3 9.99143 3 9.70425 3.07403 9.43978C3.1396 9.20552 3.24737 8.98518 3.39203 8.78959C3.55534 8.56879 3.78202 8.39248 4.23539 8.03986L11.0177 2.76473C11.369 2.49148 11.5447 2.35485 11.7387 2.30233C11.9098 2.25599 12.0902 2.25599 12.2613 2.30233C12.4553 2.35485 12.631 2.49148 12.9823 2.76473L19.7646 8.03986C20.218 8.39248 20.4447 8.56879 20.608 8.78959C20.7526 8.98518 20.8604 9.20552 20.926 9.43978C21 9.70425 21 9.99143 21 10.5658V17.8007C21 18.9208 21 19.4809 20.782 19.9087C20.5903 20.285 20.2843 20.591 19.908 20.7827C19.4802 21.0007 18.9201 21.0007 17.8 21.0007H6.2C5.0799 21.0007 4.51984 21.0007 4.09202 20.7827C3.71569 20.591 3.40973 20.285 3.21799 19.9087C3 19.4809 3 18.9208 3 17.8007V10.5658Z",
    fill: "#1B92FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 17H16",
    stroke: "#E9F4FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHomeLarge);
export default __webpack_public_path__ + "static/media/ic_home_large.9b790ca45c2adcc0466ca87ac301af87.svg";
export { ForwardRef as ReactComponent };